    // app/javascript/controllers/dynamic_select_controller.js
    import { Controller } from "@hotwired/stimulus";

    export default class extends Controller {
      static targets = ["zipcodeField", "selectNeighborhoodField", "stateField", "stateIdField", "cityField", "cityIdField", "zipcodeError"];

      connect() {
      }

      async updateSelect() {
        const query = this.zipcodeFieldTarget.value;
        if (query.length < 5) { 
          this.clearSelect();
          return;
        }

        const response = await fetch(`/zipcode/autocomplete?query=${query}`);
        const data = await response.json();

        this.clearSelect();
        data.forEach(zipcode => {
          const option = document.createElement("option");
          option.value = zipcode.id; 
          option.textContent = zipcode.neighborhood;
          this.selectNeighborhoodFieldTarget.appendChild(option);
        });


        const firstElement = data[0];
        if(firstElement === null || typeof firstElement === 'undefined'){
          this.zipcodeErrorTarget.textContent = "Código Postal Inexistente";
        }else{
          this.stateFieldTarget.value = firstElement.state;
          this.stateIdFieldTarget.value = firstElement.state_id;
          this.cityFieldTarget.value = firstElement.city;
          this.cityIdFieldTarget.value = firstElement.city_id;
        }
      }

      clearSelect() {
        this.selectNeighborhoodFieldTarget.innerHTML = '<option value="">Seleccionar Colonia</option>';
        this.stateFieldTarget.value = '';
        this.stateIdFieldTarget.value = '';
        this.cityFieldTarget.value = '';
        this.cityIdFieldTarget.value = '';
        this.zipcodeErrorTarget.textContent = '';
      }
    }